module.exports = __webpack_public_path__ + "assets/dripicons-v2.cf09c981aeaa8736810133ab1148e4a3.ttf";